import { render, staticRenderFns } from "./IntegralLog.vue?vue&type=template&id=cc387de0&scoped=true&"
import script from "./IntegralLog.vue?vue&type=script&lang=js&"
export * from "./IntegralLog.vue?vue&type=script&lang=js&"
import style0 from "./IntegralLog.vue?vue&type=style&index=0&id=cc387de0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc387de0",
  null
  
)

export default component.exports